import { Component } from '@angular/core';
import { MenuIdService } from 'src/app/core/services/menu-id.service';
import { BreakpointObserver } from '@angular/cdk/layout';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  footerContent: any;
  defaultFooter: boolean = false;
  notEmpty: boolean = true;
  currentYear: any = '';
  constructor(
    public menuIdService: MenuIdService,
    private breakpointObserver: BreakpointObserver) {
  }
  ngOnInit() {
    this.footerContent = this.menuIdService.activFooterContent()
    this.menuIdService.activFooterContent().subscribe(content => {
      this.defaultFooter = !content;
    });

    let date = new Date();
    this.currentYear = date.getFullYear();
  }

  isDesktop(): boolean {
    return this.breakpointObserver.isMatched('(min-width: 768px)');
  }

  isMobile(): boolean {
    return this.breakpointObserver.isMatched('(max-width: 767px)');
  }
}
